import axios from "axios";
import { fn_add_box_show } from "../function/FnBodyLayer";
import { select_addr_keyword_forkakao, select_addr_keyword_forkakao_pos } from "http/kakaoConn"
import { fn_address_api_pos, fn_address_api } from "function/FnBodyStep"
import { Fn_activeAxiosEtc } from "function/FnConfigEtc";

//주소검색 네이버
export function select_addr_fornaver(rootStore) {

    rootStore.viewStore.setSearchAddrCount(null);
    rootStore.viewStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
    rootStore.viewStore.setKakaoMap("", "")
    let addr = rootStore.viewStore.getDetailSearchAddr

    if (!rootStore.viewStore.getDetailSearchAddr) {
        rootStore.viewStore.initSearchAddrList();
        return;
    }

    const api = Fn_activeAxiosEtc(rootStore);
    api.get('/apiManager/api-map/addresses?query=' + addr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                let addrArr = []
                if (res.data.meta != null) {
                    for (let i = 0; i < res.data.documents.length; i++) {
                        if (res.data.documents[i].road_address.address_name != "" && res.data.documents[i].address.address_name != "" && (res.data.documents[i].road_address.address_name != res.data.documents[i].address.address_name)) {
                            if (res.data.documents[i].id == null) {
                                res.data.documents[i].id = i
                            }
                            addrArr = [...addrArr, {
                                address: res.data.documents[i].address.address_name,
                                roadAddress: res.data.documents[i].road_address.address_name,
                                x: res.data.documents[i].x,
                                y: res.data.documents[i].y,
                                id: res.data.documents[i].id
                            }]
                        }
                    }
                }
                if (addrArr.length == 0) {
                    rootStore.viewStore.setSearchAddrResult(null)
                    select_addr_keyword_formois(rootStore)//행안부api
                } else {
                    rootStore.viewStore.setSearchAddrResult("ok")
                    rootStore.viewStore.setSearchAddrList(addrArr);
                }
            }
        } else {
            //naver실패시kakao
            fn_address_api(rootStore, "kakao")
        }
    }).catch(err => {
        fn_address_api(rootStore, "kakao")
    });
}

//키워드 검색 - 주소 없을 경우 검색. 행안부
export function select_addr_keyword_formois(rootStore) {

    let addrArr = []

    if (!rootStore.viewStore.getDetailSearchAddr) {
        rootStore.viewStore.initSearchAddrList();
        return;
    }

    const api = Fn_activeAxiosEtc(rootStore);
    api.get('/apiManager/api-map/keywords?query=' + rootStore.viewStore.getDetailSearchAddr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                if (res.data.meta.total_count > 45) {
                    rootStore.viewStore.setSearchAddrResult("many")
                    rootStore.viewStore.initSearchAddrList()
                    rootStore.viewStore.setSearchAddrCount(res.data.meta.total_count)
                } else if (res.data.meta.total_count === 0) {
                    rootStore.viewStore.setSearchAddrResult(null)
                    rootStore.viewStore.initSearchAddrList()
                } else {
                    rootStore.viewStore.setSearchAddrResult("ok")
                    if (res.data.meta != null) {
                        for (let i = 0; i < res.data.documents.length; i++) {
                            if ((res.data.documents[i].address_name != null && res.data.documents[i].address_name.trim() != "") && (res.data.documents[i].road_address_name != null && res.data.documents[i].road_address_name.trim() != "")) {
                                let sameCk = addrArr.find(row =>
                                    row.address === res.data.documents[i].address_name && row.roadAddress === res.data.documents[i].road_address_name
                                )
                                if (sameCk === undefined) {
                                    if (res.data.documents[i].id == null) {
                                        res.data.documents[i].id = i
                                    }
                                    addrArr = [...addrArr, {
                                        address: res.data.documents[i].address_name,
                                        roadAddress: res.data.documents[i].road_address_name,
                                        x: res.data.documents[i].x,
                                        y: res.data.documents[i].y,
                                        id: res.data.documents[i].id
                                    }]
                                }
                            }
                        }
                    }
                    rootStore.viewStore.setSearchAddrList(addrArr);
                }
            }
        } else {
            //행안부 키워드 검색 실패시
            select_addr_keyword_forkakao(rootStore)
        }
    }).catch(err => {
        //행안부 키워드 검색 실패시
        select_addr_keyword_forkakao(rootStore)
    });
}

export async function select_addr_fornaver_detail_check(rootStore, type, searchAddress, searchRoadAddress) {

    if (!rootStore.viewStore.getDetailSearchAddr) {
        rootStore.viewStore.initSearchAddrList();
        return;
    }

    let sendAddr
    if (searchRoadAddress) {
        sendAddr = searchRoadAddress
    } else if(searchRoadAddress == "" && rootStore.viewStore.getOrderDetail.addr2 != "") {
        sendAddr = searchAddress
    } else {

        if(rootStore.viewStore.getOrderDetail.addr2 === null || rootStore.viewStore.getOrderDetail.addr2 === ""){
            sendAddr = rootStore.viewStore.getDetailSearchAddr
        }else {
            sendAddr = rootStore.viewStore.getOrderDetail.addr2
        }
    }

    //검증 주소 도로명 우선시
    if(type == "list"){
        if (searchAddress){
            sendAddr = searchAddress
        }
        if (searchRoadAddress) {
            sendAddr = searchRoadAddress
        }
    }

    const api = Fn_activeAxiosEtc(rootStore);
    let response = await api.get('/apiManager/api-map/addresses/integration?query=' + sendAddr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                let addrCnt = 0
                for (let i = 0; i < res.data.documents.length; i++) {
                    if (res.data.documents[i].road_address != null || res.data.documents[i].address != null) {
                        addrCnt++
                    }
                }
                if (addrCnt >= 1) {
                    rootStore.viewStore.setSelectedAddr(res.data.documents[0]);
                    //todo
                    // if(!ygyMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg) && !baeminMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)){
                    //     rootStore.viewStore.setKakaoMap(res.data.documents[0].y, res.data.documents[0].x)
                    // }
                    rootStore.viewStore.setKakaoMap(res.data.documents[0].y, res.data.documents[0].x)
                    return 1;
                } else {
                    rootStore.viewStore.setSelectedAddr(null);
                    return 0;
                }
            }
        }
    }).catch(err => {
    });

    return response;
}

// POS 주소 검색
//주소검색
export function select_addr_fornaver_pos(rootStore) {
    rootStore.addressSearchStore.setSearchAddrCount(null)
    rootStore.addressSearchStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
    rootStore.addressSearchStore.setKakaoMap("", "")
    let addr = rootStore.addressSearchStore.getDetailSearchAddr

    if (!rootStore.addressSearchStore.getDetailSearchAddr) {
        rootStore.addressSearchStore.initSearchAddrList();
        return;
    }

    const api = Fn_activeAxiosEtc(rootStore);
    api.get('/apiManager/api-map/addresses?query=' + addr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                let addrArr = []
                if (res.data.meta != null) {
                    for (let i = 0; i < res.data.documents.length; i++) {
                        if (res.data.documents[i].road_address.address_name != "" && res.data.documents[i].address.address_name != "" && (res.data.documents[i].road_address.address_name != res.data.documents[i].address.address_name)) {
                            if (res.data.documents[i].id == null) {
                                res.data.documents[i].id = i
                            }
                            addrArr = [...addrArr, {
                                address: res.data.documents[i].address.address_name,
                                roadAddress: res.data.documents[i].road_address.address_name,
                                x: res.data.documents[i].x,
                                y: res.data.documents[i].y,
                                id: res.data.documents[i].id
                            }]
                        }
                    }
                }
                if (addrArr.length == 0) {
                    rootStore.addressSearchStore.setSearchAddrResult(null)
                    select_addr_keyword_formois_pos(rootStore)//행안부api
                } else {
                    rootStore.addressSearchStore.setSearchAddrResult("ok")
                    rootStore.addressSearchStore.setSearchAddrList(addrArr);
                }
            }
        } else {
            fn_address_api_pos(rootStore, "kakao")
        }
    }).catch(err => {
        fn_address_api_pos(rootStore, "kakao")
    });
}

//키워드 검색 - 주소 없을 경우 검색.
export function select_addr_keyword_formois_pos(rootStore) {

    let addrArr = []

    if (!rootStore.addressSearchStore.getDetailSearchAddr) {
        rootStore.addressSearchStore.initSearchAddrList();
        return;
    }
    const api = Fn_activeAxiosEtc(rootStore);
    api.get('/apiManager/api-map/keywords?query=' + rootStore.addressSearchStore.getDetailSearchAddr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                if (res.data.meta.total_count > 45) {
                    rootStore.addressSearchStore.setSearchAddrResult("many")
                    rootStore.addressSearchStore.initSearchAddrList()
                    rootStore.addressSearchStore.setSearchAddrCount(res.data.meta.total_count)
                } else if (res.data.meta.total_count === 0) {
                    rootStore.addressSearchStore.setSearchAddrResult(null)
                    rootStore.addressSearchStore.initSearchAddrList()
                } else {
                    rootStore.addressSearchStore.setSearchAddrResult("ok")
                    if (res.data.meta != null) {
                        for (let i = 0; i < res.data.documents.length; i++) {
                            if ((res.data.documents[i].address_name != null && res.data.documents[i].address_name.trim() != "") && (res.data.documents[i].road_address_name != null && res.data.documents[i].road_address_name.trim() != "")) {
                                let sameCk = addrArr.find(row =>
                                    row.address === res.data.documents[i].address_name && row.roadAddress === res.data.documents[i].road_address_name
                                )
                                if (sameCk === undefined) {
                                    if (res.data.documents[i].id == null) {
                                        res.data.documents[i].id = i
                                    }
                                    addrArr = [...addrArr, {
                                        address: res.data.documents[i].address_name,
                                        roadAddress: res.data.documents[i].road_address_name,
                                        x: res.data.documents[i].x,
                                        y: res.data.documents[i].y,
                                        id: res.data.documents[i].id
                                    }]
                                }
                            }
                        }
                    }
                    rootStore.addressSearchStore.setSearchAddrList(addrArr);
                }
            }
        } else {
            select_addr_keyword_forkakao_pos(rootStore)
        }
    }).catch(err => {
        select_addr_keyword_forkakao_pos(rootStore)
    });
}

export async function select_addr_fornaver_detail_check_pos(rootStore, type, searchAddress, searchRoadAddress) {

    if (!rootStore.addressSearchStore.getDetailSearchAddr) {
        rootStore.addressSearchStore.initSearchAddrList();
        return;
    }
    
    let sendAddr

    //검증 주소 도로명 우선시
    if(type == "list"){
        if (searchAddress){
            sendAddr = searchAddress
        }
        if (searchRoadAddress) {
            sendAddr = searchRoadAddress
        }
    }
    
    const api = Fn_activeAxiosEtc(rootStore);
    let response = await api.get('/apiManager/api-map/addresses/integration?query=' + sendAddr, {
        headers: {
            'Authorization': 'Bearer ' + rootStore.settingStore.ActiveRestUrl.tpayToken,
        }
    }).then((res) => {
        if (res && res.status === 200) {
            if (res.data && res.data.documents) {
                let addrCnt = 0
                for (let i = 0; i < res.data.documents.length; i++) {
                    if (res.data.documents[i].road_address != null || res.data.documents[i].address != null) {
                        addrCnt++
                    }
                }
                if (addrCnt >= 1) {
                    rootStore.addressSearchStore.setSelectedAddr(res.data.documents[0]);
                    rootStore.addressSearchStore.setKakaoMap(res.data.documents[0].y, res.data.documents[0].x)
                    return 1;
                } else {
                    rootStore.addressSearchStore.setSelectedAddr(null);
                    return 0;
                }
            }
        }
    }).catch(err => {
    });

    return response;
}

